import * as Yup from 'yup';

export interface IParamsGetBach {
  codigoPedido?: string | null;
  tipo?: string | null;
  produto?: string | null;
  lote?: string | null;
  serie?: string | null;
  dataInicio?: string | null;
  dataFim?: string | null;
}

export interface IParamsGetBachAPI extends IParamsGetBach {
  codigoCliente: number;
}

export interface IBatchData {
  codigoPedido: string;
  cor: string;
  descProduto: string;
  grade: string;
  lote: string;
  produto: string;
  quantidade: number;
  serie: string;
  tamanho: string;
  tipoPedido: string;
  validade: string;
  dataRecebimento: string;
}

export interface IBatchTableProps {
  batchs: IBatchData[];
}

export const formSchema = Yup.object({
  codigoPedido: Yup.string().nullable(),
  tipo: Yup.string().nullable(),
  produto: Yup.string().nullable(),
  lote: Yup.string().nullable(),
  serie: Yup.string().nullable(),
  dataInicio: Yup.string().required('Data inicial é obrigatória'),
  dataFim: Yup.string()
    .required('Data final é obrigatória')
    .test(
      'max-30-days',
      'O intervalo entre as datas não pode ser maior que 30 dias',
      function (value) {
        const { dataInicio } = this.parent;

        if (!dataInicio || !value) return true;

        const inicio = new Date(dataInicio);
        const fim = new Date(value);

        const diffDays =
          (fim.getTime() - inicio.getTime()) / (1000 * 60 * 60 * 24);

        return diffDays <= 30;
      }
    ),
  status: Yup.string(),
});
